// DS: C135
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { CoreTypes } from '../../../types';
import { CORE_BENEFITS } from '../../../../../helpers/core';

import s from './HeroContent.scss';

export interface Props {
  coreType: CoreTypes;
}

const HeroContent: React.FC<Props> = ({ coreType }) => {
  const { t } = useTranslation();

  const logo = Url.staticCDNLink(
    `eclipse/package-picker/${coreType}_logo.svg?2`
  );
  const getTransKey = (key: string) =>
    `packagePicker.block.packages.${coreType}.${key}`;

  const benefits: React.ReactNode[] = [];
  // Skip Ad-Free benefit
  CORE_BENEFITS[coreType].forEach(i => {
    benefits.push(
      <li key={i}>
        <CheckIcon
          size={IconSize.TINY}
          className={s['benefit-icon']}
          disableDefaultColors
        />
        <div className={s['benefit-text']}>
          {t(getTransKey(`benefits.${i}`))}
        </div>
      </li>
    );
  });

  return (
    <div className={s['root']}>
      <h1 className={s['logo']}>
        <img src={logo} alt={t(getTransKey('logoAlt'))} height={64} />
      </h1>
      <ul className={s['benefit-list']}>{benefits}</ul>
    </div>
  );
};
HeroContent.displayName = 'BillingCycleHeroContent';

export default HeroContent;
